module.exports = __webpack_public_path__ + "img/tc.16e071db.png";